export default "__VITE_ASSET__34fc83bd__"